import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import ZebralearnLogoIcon from 'assets/Header/Zebralearn/ZebralearnLogoIcon';
import ZebralearnLogoText from 'assets/Header/Zebralearn/ZebralearnLogoText';
import clsx from 'clsx';
import { AnimatePresence, motion } from 'framer-motion';
import { debounce } from 'lodash';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { FC, useEffect, useMemo, useRef, useState } from 'react';
import { BiX } from 'react-icons/bi';
import { useRecoilState } from 'recoil';
import { twMerge } from 'tailwind-merge';

import useTailwindBreakpoint from '@/hooks/useTailwindBreakpoint';

import RenderIf from '@/components/Common/RenderIf';
import { Course } from '@/components/Courses/CoursesCard';
import Menus from '@/components/Layout/Header/Menus';
import Options from '@/components/Layout/Header/Options';
import Search from '@/components/Layout/Header/Search';
import ContactDropdown from '@/components/Layout/Header/Search/ContactDropdown';
import Suggestions from '@/components/Layout/Header/Search/Suggestions';
import { ILinks } from '@/components/Layout/ProductsHeader';

import { aiModalOpenAtomGlobal } from '@/atoms/pdfStates/aiModalOpenAtom';
import { getBlogPagination } from '@/services/blog';
import { getCourseReaderList } from '@/services/Courses';
import { getAllBookListApi } from '@/services/Library/Books';
import { getAllBundleListApi } from '@/services/Library/Bundle';
import { getAllOrangesBookListApi } from '@/services/Library/Oranges';
import { IRouteBanner } from '@/services/RouteBanner';
import { Book } from '@/utils/interfaces/Library/Books';
import { isProgrammaticScroll } from '@/utils/ScrollControl/scrollControl';

import { ISchool } from '@/types/schools';
interface Props {
  isSearch: boolean;
  shouldRenderLinks: boolean;
  links: ILinks[];
  timeoutIdRef: React.MutableRefObject<NodeJS.Timeout | null>;
  setHoveredIndex: React.Dispatch<React.SetStateAction<number | null>>;
  setOpenDropDown: React.Dispatch<React.SetStateAction<boolean>>;
  openZaiDrawer: () => void;
  openDropDown: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  hoveredIndex: number | null;
  searchKeyword: string | undefined;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  setSearchKeyword: React.Dispatch<React.SetStateAction<string | undefined>>;
  setShowSearch: React.Dispatch<React.SetStateAction<boolean>>;
  keyCount: number;
  loggedIn: boolean;
  validPathSearch: string[];
  showSearch: boolean;
  isShopPage: boolean;
  chatCountValue: number;
  hasNewBook: boolean;
  dropdownMenu: React.JSX.Element;
  showDropDown: boolean;
  setShowDropDown: React.Dispatch<React.SetStateAction<boolean>>;
  showDrawer: () => void;
  dropdownRef: React.MutableRefObject<HTMLDivElement | null>;
  userName: string | undefined;
  isMatchingRoute: boolean;
  isSchoolsPage: boolean;
  isPdf: boolean;
  isBannerVisibleValue: boolean | null;
  isCartPage: boolean;
  isPlatformCheckoutPage: boolean;
  isCheckoutPage: boolean;
  validPathSearchNav: string[];
  isDesktop: boolean | undefined;
  isShadow: boolean;
  isZai: boolean;
  isTrueCheckoutPage: boolean;
  showBorder: boolean;
  shortHeaderInPhone: boolean;
  showBanner: boolean;
  routeBanner: IRouteBanner | null;
  setShowBanner: React.Dispatch<React.SetStateAction<boolean>>;
}
const Header: FC<Props> = ({
  setShowBanner,
  routeBanner,
  showBanner,
  showBorder,
  isTrueCheckoutPage,
  isSearch,
  isZai,
  hoveredIndex,
  setOpen,
  openDropDown,
  openZaiDrawer,
  setHoveredIndex,
  links,
  shouldRenderLinks,
  timeoutIdRef,
  setOpenDropDown,
  handleInputChange,
  setShowSearch,
  keyCount,
  loggedIn,
  validPathSearch,
  showSearch,
  isShopPage,
  chatCountValue,
  hasNewBook,
  dropdownMenu,
  showDropDown,
  setShowDropDown,
  showDrawer,
  dropdownRef,
  userName,
  // isMatchingRoute,
  // isSchoolsPage,
  isPdf,
  isBannerVisibleValue,
  isCartPage,
  isPlatformCheckoutPage,
  isCheckoutPage,
  validPathSearchNav,
  isDesktop,
  shortHeaderInPhone,
}) => {
  const router = useRouter();
  const [openDrawerGlobal] = useRecoilState<boolean>(aiModalOpenAtomGlobal);
  const [search, setSearch] = useState<string>('');
  const [books, setBooks] = useState<Book[]>([]);
  const [oranges, setOranges] = useState<Book[]>([]);
  const [bundles, setBundles] = useState<Book[]>([]);
  const [schools, setSchools] = useState<ISchool[]>([]);
  const [courses, setCourses] = useState<Course[]>([]);
  const [showSuggestionsPhone, setShowSuggestionsPhone] = useState(false);
  const searchPhoneRef = useRef<HTMLDivElement>(null);

  const screens = useBreakpoint();
  const twScreens = useTailwindBreakpoint();
  const lastScrollY = useRef(0);
  // const isUserScrolling = useRef(false);
  // const scrollTimeout = useRef<NodeJS.Timeout | null>(null);
  // const offset = useRef(0);

  const getSecondRowDimansions = (): {
    height: number;
    peddingBottom: number;
    adjustment: number;
  } => {
    if (twScreens.xl) {
      return { height: 40, peddingBottom: 16, adjustment: 0 };
    } else if (twScreens.lg) {
      return { height: 32, peddingBottom: 16, adjustment: 0 };
    } else if (twScreens.md) {
      return { height: 32, peddingBottom: 14, adjustment: -4 };
    } else if (twScreens.sm) {
      return { height: 32, peddingBottom: 16, adjustment: -8 };
    } else {
      return { height: 40, peddingBottom: 12, adjustment: 0 };
    }
  };

  const TOP_THRESHOLD = 10; // px

  const SECOND_ROW_HEIGHT =
    getSecondRowDimansions().height +
    getSecondRowDimansions().peddingBottom -
    2 +
    getSecondRowDimansions().adjustment;

  // const [translateY, setTranslateY] = useState(0);
  const [isSecondRowHidden, setIsSecondRowHidden] = useState(false);

  // useEffect(() => {
  //   const handleScroll = () => {
  //     const currentScrollY = window.scrollY;
  //     const delta = currentScrollY - lastScrollY.current;

  //     offset.current += delta;

  //     // clamp between 0 and height
  //     if (offset.current < 0) offset.current = 0;
  //     if (offset.current > SECOND_ROW_HEIGHT)
  //       offset.current = SECOND_ROW_HEIGHT;

  //     setTranslateY(offset.current);

  //     lastScrollY.current = currentScrollY;
  //   };

  //   window.addEventListener('scroll', handleScroll, { passive: true });

  //   return () => window.removeEventListener('scroll', handleScroll);
  // }, [SECOND_ROW_HEIGHT]);
  // xl:py-4 sm:py-[14px] py-3 2xl:px-8 xl:px-5 lg:px-4 sm:px-4
  // useEffect(() => {
  //   const markUserScroll = () => {
  //     isUserScrolling.current = true;

  //     if (scrollTimeout.current) {
  //       clearTimeout(scrollTimeout.current);
  //     }

  //     scrollTimeout.current = setTimeout(() => {
  //       isUserScrolling.current = false;
  //     }, 150);
  //   };

  //   window.addEventListener('wheel', markUserScroll, { passive: true });
  //   window.addEventListener('touchmove', markUserScroll, { passive: true });
  //   window.addEventListener('keydown', markUserScroll, { passive: true });

  //   return () => {
  //     window.removeEventListener('wheel', markUserScroll);
  //     window.removeEventListener('touchmove', markUserScroll);
  //     window.removeEventListener('keydown', markUserScroll);
  //   };
  // }, []);
  // useEffect(() => {
  //   const markUserScroll = () => {
  //     isUserScrolling.current = true;

  //     if (scrollTimeout.current) {
  //       clearTimeout(scrollTimeout.current);
  //     }

  //     scrollTimeout.current = setTimeout(() => {
  //       isUserScrolling.current = false;
  //     }, 150);
  //   };

  //   // KEY FIX: use touchstart instead of touchmove
  //   window.addEventListener('touchstart', markUserScroll, { passive: true });

  //   // keep these
  //   window.addEventListener('wheel', markUserScroll, { passive: true });
  //   window.addEventListener('keydown', markUserScroll, { passive: true });

  //   return () => {
  //     window.removeEventListener('touchstart', markUserScroll);
  //     window.removeEventListener('wheel', markUserScroll);
  //     window.removeEventListener('keydown', markUserScroll);
  //   };
  // }, []);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        searchPhoneRef.current &&
        !searchPhoneRef.current.contains(event.target as Node)
      ) {
        setShowSuggestionsPhone(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      // Ignore programmatic scroll
      if (isProgrammaticScroll.current) {
        lastScrollY.current = window.scrollY;
        return;
      }

      const currentScrollY = window.scrollY;

      if (currentScrollY <= TOP_THRESHOLD) {
        if (isSecondRowHidden) {
          setIsSecondRowHidden(false);
        }
        lastScrollY.current = currentScrollY;
        return;
      }

      const isScrollingDown = currentScrollY > lastScrollY.current;
      const isScrollingUp = currentScrollY < lastScrollY.current;

      if (isScrollingDown && !isSecondRowHidden) {
        setIsSecondRowHidden(true);
      }

      if (isScrollingUp && isSecondRowHidden) {
        setIsSecondRowHidden(false);
      }

      lastScrollY.current = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => window.removeEventListener('scroll', handleScroll);
  }, [isSecondRowHidden]);

  useEffect(() => {
    const handleRouteChange = () => {
      setIsSecondRowHidden(false);
      lastScrollY.current = 0;
    };

    router.events.on('routeChangeStart', handleRouteChange);

    return () => {
      router.events.off('routeChangeStart', handleRouteChange);
    };
  }, [router.events]);
  // const isSecondRowOptions = translateY >= SECOND_ROW_HEIGHT && twScreens.lg;

  const isSecondRowOptions = isSecondRowHidden && twScreens.lg;
  const secondRowCondition =
    !isZai &&
    !isPdf &&
    !router.pathname.startsWith('/course/') &&
    !isSecondRowOptions &&
    !router.asPath.includes('/policies') &&
    shouldRenderLinks &&
    !isTrueCheckoutPage &&
    !isCartPage &&
    !isPlatformCheckoutPage;

  const debouncedSearch = useMemo(
    () =>
      debounce(async (keyword: string) => {
        try {
          const bookResult = await getAllBookListApi({ page: '1', keyword });
          const courseResult = await getCourseReaderList({
            page: '1',
            categoriesId: null,
            keyword,
            limit: '4',
          });
          const schoolResult = await getBlogPagination({ page: '1', keyword });
          const bundleResult = await getAllBundleListApi({
            page: '1',
            keyword,
          });
          const orangesResult = await getAllOrangesBookListApi({
            page: '1',
            keyword,
          });
          setBooks(bookResult?.data || []);
          setCourses(courseResult?.data?.data || []);
          setSchools(schoolResult?.data?.data || []);
          setBundles(bundleResult?.data || []);
          setOranges(orangesResult?.data || []);
        } catch (error) {
          console.error(error);
        }
      }, 300),
    [],
  );

  useEffect(() => {
    debouncedSearch(search);

    return () => {
      debouncedSearch.cancel();
    };
  }, [search]);

  useEffect(() => {
    setShowSuggestionsPhone(false);
  }, [isSecondRowHidden]);

  const getBannerTextAccordingScreens = () => {
    if (!routeBanner) return;
    if (twScreens.lg) {
      return routeBanner.text;
    }
    if (twScreens.sm) {
      return routeBanner.textTab;
    }
    return routeBanner.textPhone;
  };
  return (
    <>
      <div
        className={twMerge(
          'h-0 w-full xl:mb-[127px] lg:mb-[107px] md:mb-[101px] sm:mb-[101px] mb-[105px] ',
          isSearch
            ? 'xl:mb-[127px] lg:mb-[108px] md:mb-[142px] sm:mb-[142px] mb-[158px]'
            : '',
          isZai || isPdf || router.pathname.startsWith('/course/') ? 'xl:mb-0 lg:mb-0 md:mb-0 sm:mb-0 mb-0' : '',
          isCartPage
            ? '2xl:mb-[70px] xl:mb-[70px] lg:mb-[60px] md:mb-[60px]  sm:mb-[54px] mb-[56px]'
            : '',
          isTrueCheckoutPage
            ? '2xl:mb-[70px] xl:mb-[70px] lg:mb-[60px] md:mb-[60px]  sm:mb-[54px] mb-[56px]'
            : '',
          isPlatformCheckoutPage
            ? '2xl:mb-[70px] xl:mb-[70px] lg:mb-[60px] md:mb-[60px]  sm:mb-[54px] mb-[56px]'
            : '',
          shortHeaderInPhone
            ? '2xl:mb-[56px] xl:mb-[56px] lg:mb-[56px] md:mb-[56px]  sm:mb-[56px] mb-[56px]'
            : '',
          showBanner && routeBanner !== null ? 'h-12' : '',
        )}
      />
      <nav
        id='main-header'
        className={twMerge(
          clsx(
            'top-0',
            openDrawerGlobal ? 'z-[2000]' : 'z-40',
            !isPdf && 'fixed',
            isBannerVisibleValue &&
              !isCartPage &&
              !isPlatformCheckoutPage &&
              isCheckoutPage &&
              validPathSearchNav.some((path) => path === router.pathname) &&
              !isDesktop
              ? `mt-12 md:mt-12 `
              : 'mt-0 -translate-y-0',
            // !isShadow ? 'shadow-md' : '',
          ),
          router.pathname === '/zai' || router.pathname.startsWith('/course/')
            ? 'bg-grayZl-925 shadow-none border-b border-grayZl-900'
            : '',
          'w-full',
          !isSecondRowHidden ? 'bg-black transition-all duration-700' : '',
          '',
        )}
      >
        <>
          <AnimatePresence initial={false}>
            {showBanner && routeBanner !== null && routeBanner && (
              <motion.div
                key='route-banner'
                initial={{ height: 0, opacity: 0 }}
                animate={{ height: 48, opacity: 1 }}
                exit={{ height: 0, opacity: 0 }}
                transition={{ duration: 0.3, ease: [0.4, 0, 0.2, 1] }}
                className='overflow-hidden'
              >
                <div
                  onClick={() => router.push(routeBanner.link)}
                  className='relative z-50 w-full h-12 bg-stroke flex items-center sm:justify-center justify-between px-3 gap-2.5'
                >
                  <div className='flex items-center gap-2.5 sm:justify-center justify-between flex-1'>
                    <RenderIf condition={twScreens.sm}>
                      <div
                        className='[&_svg]:h-4 [&_svg]:w-4'
                        style={{ width: '16px', height: '16px' }}
                        dangerouslySetInnerHTML={{
                          __html: routeBanner.iconSvg,
                        }}
                      />
                    </RenderIf>
                    <p
                      className='text-xs font-medium line-clamp-1'
                      style={{ color: routeBanner.textColor }}
                    >
                      {getBannerTextAccordingScreens()}
                    </p>
                    <button
                      className='px-2.5 py-[5px] rounded border text-xs font-medium'
                      style={{
                        borderColor: routeBanner.buttonColor,
                        backgroundColor: routeBanner.buttonColor,
                        color: routeBanner.buttonTextColor,
                      }}
                    >
                      {routeBanner.buttonText}
                    </button>
                  </div>
                  <div className='h-full sm:absolute top-0 right-0 flex items-center justify-center'>
                    <BiX
                      className='w-5 h-5 text-grayZl-500 sm:mx-6 cursor-pointer'
                      onClick={(e) => {
                        e.stopPropagation();
                        if (routeBanner?._id && typeof window !== 'undefined') {
                          const expireHours = routeBanner.expireIn || 24;
                          const expiryTime =
                            Date.now() + expireHours * 60 * 60 * 1000;
                          localStorage.setItem(
                            `routeBannerClosed_${routeBanner._id}`,
                            String(expiryTime),
                          );
                        }
                        setShowBanner(false);
                      }}
                    />
                  </div>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
          <div className={twMerge('', isZai || router.pathname.startsWith('/course/') ? 'bg-grayZl-925' : '')}>
            <div
              className={twMerge(
                'z-30 relative flex items-center  justify-between  2xl:gap-[109px] xl:gap-[29px] lg:gap-[19px] xl:pt-4 sm:pt-[14px] pt-3 2xl:px-8 xl:px-5 lg:px-4 sm:px-4 px-4',
                isZai || isPdf || router.pathname.startsWith('/course/')
                  ? ' xl:pb-4 sm:pb-[14px] pb-3'
                  : 'lg:pb-[14px] sm:pb-[8px] pb-3 ',
                isZai || router.pathname.startsWith('/course/') ? 'bg-grayZl-925' : 'bg-black',
                isSecondRowOptions && showBorder
                  ? 'border-b-[0.5px] border-grayZl-850'
                  : '',
              )}
            >
              <Link href='/' className='flex items-center xxs:gap-3 gap-2.5'>
                <ZebralearnLogoIcon className='xxs:w-3 xxs:h-3 xxs:min-w-3 xxs:min-h-3 w-2.5  h-2.5 min-w-2.5  min-h-2.5 ' />
                <ZebralearnLogoText
                  width='auto'
                  className='xxs:h-3 xxs:min-h-3 xxs:w-[120px] xxs:min-w-[120px] h-2.5 min-h-2.5 w-[100px] min-w-[100px] '
                />
              </Link>
              <RenderIf condition={(isZai || isPdf || router.pathname.startsWith('/course/')) && screens.xl}>
                <Options
                  isPdf={isPdf}
                  isZai={isZai}
                  hoveredIndex={hoveredIndex}
                  setOpen={setOpen}
                  openDropDown={openDropDown}
                  openZaiDrawer={openZaiDrawer}
                  setOpenDropDown={setOpenDropDown}
                  setHoveredIndex={setHoveredIndex}
                  timeoutIdRef={timeoutIdRef}
                  links={links}
                  shouldRenderLinks={shouldRenderLinks}
                />
              </RenderIf>
              <RenderIf
                condition={
                  !isPdf &&
                  !isZai &&
                  !router.pathname.startsWith('/course/') &&
                  isSecondRowOptions &&
                  !isTrueCheckoutPage &&
                  !isCartPage &&
                  !isPlatformCheckoutPage
                }
              >
                <Options
                  isPdf={isPdf}
                  isZai={isZai}
                  hoveredIndex={hoveredIndex}
                  setOpen={setOpen}
                  openDropDown={openDropDown}
                  openZaiDrawer={openZaiDrawer}
                  setOpenDropDown={setOpenDropDown}
                  setHoveredIndex={setHoveredIndex}
                  timeoutIdRef={timeoutIdRef}
                  links={links}
                  shouldRenderLinks={shouldRenderLinks}
                />
              </RenderIf>

              <div className='flex items-center gap-2.5 flex-1 justify-end'>
                <RenderIf
                  // condition={!isZai && !isPdf && translateY < SECOND_ROW_HEIGHT}
                  condition={
                    !isZai &&
                    !isPdf &&
                    !isSecondRowHidden &&
                    !isTrueCheckoutPage &&
                    !isCartPage &&
                    !isPlatformCheckoutPage
                  }
                >
                  <Search
                    isSecondRowHidden={isSecondRowHidden}
                    schools={schools}
                    showSuggestionsPhone={showSuggestionsPhone}
                    bundles={bundles}
                    courses={courses}
                    books={books}
                    oranges={oranges}
                    search={search}
                    setSearch={setSearch}
                    // suggestions={isFocused}
                    newIconId='first'
                    isSearch={isSearch}
                    validPathSearch={validPathSearch}
                    isShopPage={isShopPage}
                    showSearch={showSearch}
                    setShowSearch={setShowSearch}
                    handleInputChange={handleInputChange}
                    classNameContact='hidden'
                    className='lg:flex hidden'
                  />
                </RenderIf>
                <Menus
                  isTrueCheckoutPage={isTrueCheckoutPage}
                  isCartPage={isCartPage}
                  isPlatformCheckoutPage={isPlatformCheckoutPage}
                  userName={userName}
                  dropdownRef={dropdownRef}
                  showDrawer={showDrawer}
                  setShowDropDown={setShowDropDown}
                  showDropDown={showDropDown}
                  dropdownMenu={dropdownMenu}
                  hasNewBook={hasNewBook}
                  chatCountValue={chatCountValue}
                  validPathSearch={validPathSearch}
                  shouldRenderLinks={shouldRenderLinks}
                  loggedIn={loggedIn}
                  keyCount={keyCount}
                />
              </div>
            </div>
            <RenderIf condition={!shortHeaderInPhone}>
              <div
                // style={{
                //   transform: `translateY(-${translateY}px)`,
                // }}
                style={{
                  transform: isSecondRowHidden
                    ? `translateY(-${SECOND_ROW_HEIGHT}px)`
                    : `translateY(0px)`,
                }}
                className='relative z-20 flex sm:justify-center justify-start flex-1 sm:px-0 px-4 bg-black transition-transform duration-300'
                onClick={() => setShowSuggestionsPhone(true)}
                ref={searchPhoneRef}
              >
                <div className='relative flex flex-1 sm:justify-center justify-start bg-black transition-transform duration-300'>
                  <RenderIf condition={isSearch && !isZai && !isPdf}>
                    <Search
                      isSecondRowHidden={isSecondRowHidden}
                      schools={schools}
                      showSuggestionsPhone={showSuggestionsPhone}
                      courses={courses}
                      bundles={bundles}
                      books={books}
                      oranges={oranges}
                      search={search}
                      setSearch={setSearch}
                      newIconId='second'
                      isSearch={isSearch}
                      validPathSearch={validPathSearch}
                      isShopPage={isShopPage}
                      showSearch={showSearch}
                      setShowSearch={setShowSearch}
                      handleInputChange={handleInputChange}
                      className='lg:hidden flex'
                    />
                  </RenderIf>
                  <RenderIf condition={isSearch && !isZai && !isPdf}>
                    <ContactDropdown
                      isSecondRowHidden={isSecondRowHidden}
                      className={twMerge(
                        '',
                        showSuggestionsPhone
                          ? 'rounded-br-none border-b-0 bg-grayZl-925 border-grayZl-900'
                          : '',
                      )}
                    />
                  </RenderIf>
                  <RenderIf
                    condition={
                      isSearch &&
                      !isZai &&
                      !isPdf &&
                      showSuggestionsPhone &&
                      !twScreens.sm
                    }
                  >
                    <Suggestions
                      onClickBook={() => {
                        setShowSuggestionsPhone(false);
                      }}
                      onClickTrending={() => {
                        setShowSuggestionsPhone(false);
                      }}
                      bundles={bundles}
                      courses={courses}
                      books={books}
                      oranges={oranges}
                      schools={schools}
                      mode={search ? 'suggestions' : 'tranding'}
                      className='top-[39.5px] w-full left-0'
                    />
                  </RenderIf>
                </div>
              </div>
            </RenderIf>
            <RenderIf condition={secondRowCondition && !shortHeaderInPhone}>
              <div
                style={{
                  // transform: `translateY(-${translateY}px)`,
                  transform: isSecondRowHidden
                    ? `translateY(-${SECOND_ROW_HEIGHT}px)`
                    : `translateY(0px)`,
                }}
                className='border-b-[0.5px] border-grayZl-850  z-10 will-change-transform xl:pb-4 transition-all duration-300 sm:pb-[14px] pb-3 2xl:px-8 xl:px-5 lg:px-4 sm:px-4 bg-black'
              >
                <Options
                  isPdf={isPdf}
                  isZai={isZai}
                  hoveredIndex={hoveredIndex}
                  setOpen={setOpen}
                  openDropDown={openDropDown}
                  openZaiDrawer={openZaiDrawer}
                  setOpenDropDown={setOpenDropDown}
                  setHoveredIndex={setHoveredIndex}
                  timeoutIdRef={timeoutIdRef}
                  links={links}
                  shouldRenderLinks={shouldRenderLinks}
                />
              </div>
            </RenderIf>
          </div>
        </>
      </nav>
    </>
  );
};

export default Header;
